export interface ApiResponseModel<T> {
  data: T;
}

export interface PageModel {
  total: number;
  page: number;
  pageSize: number;
}

export interface PageParams {
  page: number;
  pageSize: number;
}

export interface ApiListResponseModel<T> {
  data: T;
  page: PageModel;
  sort?: SortParamsModel;
}

export interface GridRequest<TFilter> {
  pagination: PageParamsModel;
  sort: SortParamsModel;
  filter: TFilter;
}

export interface PageParamsModel {
  page: number;
  pageSize: number;
}

export interface SortParamsModel {
  field: string;
  direction: GridSortDirection;
}

export type GridSortDirection = "asc" | "desc" | "none";
